// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------

// HEADER-LOGO

 gsap.registerPlugin(ScrollTrigger);
 
      // FIRST SVG – untouched
      gsap.set("#first-logo > svg", { x: 0, opacity: 1 });
 
      // SECOND SVG – start from right
      gsap.set("#second-logo", {
        x: -150,
        opacity: 0,
      });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: "header",
          start: "top -20%",
          end: "+=1",
          scrub: 1,
        },
      });
 
      const letters = [
        "#Logo-I",
        "#Logo-H",
        "#Logo-C",
        "#Logo-A2",
        "#Logo-A1",
        "#Logo-M",
        "#Logo-O",
        "#Logo-B",
      ];
 
      letters.forEach((el, i) => {
        tl.to(
          el,
          {
            x: -400,
            opacity: 0,
            duration: 0.02,
            ease: "power2.inOut",
          },
          i * 0.02
        );
      });
      
      // SECOND SVG – slide right to left + fade in
      gsap.to(
        "#second-logo",
        {
          x: 0,
          opacity: 1,
          duration: 5,
           scrollTrigger: {
            trigger: "header",
            start: "top -20%",
            end: "+=200",
            scrub: 1,
          },
        }
        );
// HEADER-LOGO

// working with reload -- filter

document.addEventListener('DOMContentLoaded', function () {
 const sizeFilterInputs = document.querySelectorAll('input[name^="filter.v.option"]');
 sizeFilterInputs.forEach(input => {
   input.addEventListener('change', function () {
     const form = input.closest('form');
     const formData = new FormData(form);
     const params = new URLSearchParams(formData);
     // Add availability filter only if not already present
     if (!params.has('filter.v.availability')) {
       params.append('filter.v.availability', '1');
     }
     window.location.search = params.toString();
   });
 });
});



// working with reload -- filter

// --------- MAC quick-add-model close ---------
 
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("click", (e) => {
    const clickedElement = e.target;
    const model = clickedElement.closest(".quick-add-modal");
    // console.log(clickedElement)
    if (clickedElement.classList.contains("quick-add-modal__content") && model.hasAttribute("open")) {
      model.removeAttribute("open");
      document.body.classList.remove("overflow-hidden");
    }
  });
});

// --------- MAC quick-add-model close ---------

// hide pdp inventory left badge

document.addEventListener('DOMContentLoaded', function () {
  const imgSlider = document.querySelector("slider-component.slider-mobile-gutter");
  const pdpInventoryTag = document.querySelector(".product__info-container .my-stocks");
  if(!imgSlider || !pdpInventoryTag) return;
  document.addEventListener("scroll",()=>{
    if(imgSlider.offsetHeight<(scrollY+200)){
      pdpInventoryTag.style.display = "none"
    }else{
      pdpInventoryTag.style.display = "unset"
    }
  })
})
// hide pdp inventory left badge


// ========== Out of stock ==========

// Function to update stock status immediately
function updateStockStatus(isOutOfStock) {
  const inventoryElement = document.querySelector(
    ".my-inventory.product__inventory"
  );

  if (isOutOfStock) {
    // Update to out of stock
    inventoryElement.innerHTML = `
      <span class="svg-wrapper" style="color: #C80505">
        <!-- Out of stock icon or alternative -->
      </span>
      Out of stock
    `;
  } else {
    // Update to in stock
    inventoryElement.innerHTML = `
      <span class="svg-wrapper" style="color: #C80505">
        <!-- In stock icon or alternative -->
      </span>
      In stock
    `;
  }
}

// Listen for changes to your specific button
document.addEventListener("DOMContentLoaded", function () {
  const targetButton = document.querySelector(
    ".product-form__submit"
  );

  if (targetButton) {
    // Watch for disabled attribute changes on your button
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "disabled"
        ) {
          const isDisabled = targetButton.hasAttribute("disabled");
          updateStockStatus(isDisabled);
        }
      });
    });

    observer.observe(targetButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });

    // Also check initial state
    const isInitiallyDisabled = targetButton.hasAttribute("disabled");
    updateStockStatus(isInitiallyDisabled);
  }

  // Listen for variant/option changes that might affect stock
  const variantSelectors = document.querySelectorAll(
    'select[name*="id"], input[name*="id"], .product-form__input'
  );
  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      // Small delay to let the button state update first
      setTimeout(() => {
        const button = document.querySelector(
          "#ProductSubmitButton-template--17032878817346__main"
        );
        if (button) {
          const isDisabled = button.hasAttribute("disabled");
          updateStockStatus(isDisabled);
        }
      }, 100);
    });
  });
});

// Alternative approach using Shopify's variant change events (if using Shopify)
document.addEventListener("variant:change", function (event) {
  const variant = event.detail.variant;
  const isOutOfStock = !variant || !variant.available;
  updateStockStatus(isOutOfStock);
});

// ========== Out of stock ==========

// --- Header BG start  --------------

document.addEventListener("DOMContentLoaded", () => {
  const mainHeader = document.querySelector(".main-header");

    if (window.scrollY > mainHeader.offsetHeight) {
      mainHeader.classList.add("active");
    } else {
      mainHeader.classList.remove("active");
    }

  document.addEventListener("scroll", () => {
    if (window.scrollY > mainHeader.offsetHeight) {
      mainHeader.classList.add("active");
    } else {
      mainHeader.classList.remove("active");
    }
  });
});

// --- Header BG end --------------

// --- STOP SCROLL ON HOVER box---
document.addEventListener("DOMContentLoaded", () => {
  const hoverElement = document.querySelector('.plz-hoverme');

  if (hoverElement) {
    hoverElement.addEventListener('mouseenter', () => {
      document.documentElement.classList.add("lock-hover");
      document.body.classList.add("lock-hover");
      lenis?.stop?.();
    });

    hoverElement.addEventListener('mouseleave', () => {
      document.documentElement.classList.remove("lock-hover");
      document.body.classList.remove("lock-hover");
      if (!isAnyScrollLockActive()) lenis?.start?.();
    });
  }
// --- STOP SCROLL ON HOVER box---



  
  
  // --- STOP SCROLL ON SEARCH BOX OPEN ---
  const searchBox = document.querySelector('.my-search-box');
  if (searchBox) {
    new MutationObserver(() => {
      const isActive = searchBox.classList.contains('active');
      document.documentElement.classList.toggle('lock-search', isActive);
      document.body.classList.toggle('lock-search', isActive);
      if (isAnyScrollLockActive()) {
        lenis?.stop?.();
      } else {
        lenis?.start?.();
      }
    }).observe(searchBox, { attributes: true, attributeFilter: ['class'] });
  }

  
  // --- Helper Function ---
  function isAnyScrollLockActive() {
    return (
      document.documentElement.classList.contains('lock-hover') ||
      document.documentElement.classList.contains('lock-search')
    );
  }
});

  // --- STOP SCROLL ON SEARCH BOX OPEN ---

  



// --------------------- New In Grid Collection Select Logic -----------------------

  document.addEventListener('DOMContentLoaded', function () {
    const gridElement = document.querySelector('.cust-collection-page2 .grid');
    const gridOptions = document.querySelectorAll('#grid-options li[data-columns]');
    const eVid1 = document.querySelector('.cust-collection-page2 .product-grid .e-vid-1');
    const eVid2 = document.querySelector('.cust-collection-page2 .product-grid .e-vid-2');
    const grid_1 = document.querySelector('.cust-collection-page2 .grid .grid__item:first-child');
    const grid_6 = document.querySelector('.cust-collection-page2 .grid .grid__item:nth-child(6)');

    gridOptions.forEach(option => {
      option.addEventListener('click', () => {
        const checkDevice = option.classList.contains("desktop");
        if(checkDevice){
          option.parentNode.querySelector(".desktop.active").classList.remove("active");
          option.classList.add("active");
        }else{
          option.parentNode.querySelector(".mobile.active").classList.remove("active");
          option.classList.add("active");
        }
        const columns = parseInt(option.getAttribute('data-columns'), 10);
        const productItems = gridElement.querySelectorAll('.cust-collection-page2 .grid__item');

        if(columns==1){
          gridElement.style.display = 'unset';
          gridElement.querySelectorAll(".grid__item").forEach(item => {item.style.padding="2%"});
        }else{
          gridElement.style.display = 'grid';
          gridElement.querySelectorAll(".grid__item").forEach(item => {item.style.padding="auto"});
        }
        gridElement.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
        
    // Set grid-column-start for .e-vid-1

    if(columns === 6 ){
      gridElement.classList.add("add-class-6")
    }else{
      gridElement.classList.remove("add-class-6")
    }

     if(columns === 1 ){

       eVid1.style.gridColumnStart='1';
       eVid1.style.gridColumn='auto';
       eVid2.style.gridColumn='auto';
       grid_1.style.gridColumn='auto';
       grid_1.style.padding=0;
       grid_6.style.gridColumn='auto';
       grid_6.style.padding=0;
          if (productItems.length > 6) {
            eVid1.style.display = 'block';

            if(productItems.length > 11){
              eVid2.style.display = 'block';
            }
            else{
              eVid2.style.display = 'none';
            }
            
          } else {
            eVid1.style.display = 'none';
          }
       }
        
       else if(columns === 2 ){
        
         eVid1.style.gridColumnStart='1';
         eVid1.style.gridColumn='span 2/ span 2';
         eVid2.style.gridColumn='span 2/ span 2';
         grid_1.style.gridColumn='span 2/ span 2';
         grid_1.style.padding='2%';
         grid_6.style.gridColumn='span 2/ span 2';
         grid_6.style.padding='2%';
          if (productItems.length > 6) {
            eVid1.style.display = 'block';

            if(productItems.length >11){
              eVid2.style.display = 'block';
            }
            else{
              eVid2.style.display = 'none';
            }
            
          } else {
            eVid1.style.display = 'none';
          }
       }

       else if (columns === 3) {
          eVid1.style.gridColumnStart = '3';
          
           if (productItems.length > 3) {
            eVid1.style.display = 'block';

             if (productItems.length > 7){
              eVid2.style.display = 'block';
            }
            else{
              eVid2.style.display = 'none';
            }
             
          } else {
            eVid1.style.display = 'none';
          }
          
        } else if (columns === 4) {
         
          eVid1.style.gridColumnStart = '4';
          
           if (productItems.length > 4) {
            eVid1.style.display = 'block';

            if (productItems.length > 9){
              eVid2.style.display = 'block';
            }
            else{
              eVid2.style.display = 'none';
            }
             
          } else {
            eVid1.style.display = 'none';
          }
          
        } else if (columns === 6) {
           eVid1.style.gridColumnStart = '6';
      
          if (productItems.length > 6) {
            eVid1.style.display = 'block';

             if (productItems.length > 13){
              eVid2.style.display = 'block';
            }
            else{
              eVid2.style.display = 'none';
            }
            
          } else {
            eVid1.style.display = 'none';
          }
          
        }

        // Highlight selected grid option
        gridOptions.forEach(opt => opt.classList.remove('active'));
        option.classList.add('active');
      });
    });
  });




// --------------- animate--slide-in applied only for desktop --------------
document.addEventListener('DOMContentLoaded', function () {
    const gridItems = document.querySelectorAll(' .product-grid-container .collection  .grid__item');
    const mediaQuery = window.matchMedia('(max-width: 950px)'); // Mobile screen width

    function updateScrollTriggerClasses() {
        gridItems.forEach(item => {
            if (mediaQuery.matches) {
                // Remove classes for mobile
                item.classList.remove('scroll-trigger', 'animate--slide-in');
            } else {
                // Add classes for desktop/tablet
                if (settings.animations_reveal_on_scroll) {
                    item.classList.add('scroll-trigger', 'animate--slide-in');
                }
            }
        });
    }

    // Run the function on initial load
    updateScrollTriggerClasses();

    // Update the classes when the window is resized
    mediaQuery.addEventListener('change', updateScrollTriggerClasses);
});
// --------------- animate--slide-in applied only for desktop end --------------



// --------------------- New In Grid Collection Select Logic End -----------------------





// -------pdp ------featured collection <sup> chnages -------
  document.addEventListener("DOMContentLoaded", () => {
    if (!window.location.pathname.includes('/products')) return;

    const container = document.querySelector('.featured-my-cust-heading');
    if (!container) return;

    const selectors = {
      right: '.f-cust-h-right',
      defPdp: '.me-def-pdp',
      def: '.me-def'
    };

    const right = container.querySelector(selectors.right);
    const defPdp = container.querySelector(selectors.defPdp);
    const def = container.querySelector(selectors.def);

    if (right) right.style.display = 'none';
    if (defPdp) defPdp.style.display = 'block';
    if (def) def.style.display = 'none';

    //  Naya wala code — footer-scroll-image hide karna with !important
  // const footerImage = document.querySelector('.footer-scroll-image');
  // if (footerImage) {
  //   footerImage.style.setProperty('display', 'none', 'important');
  // }
    //  Naya wala code — footer-scroll-image hide karna with !important
  });
// -------pdp ------featured collection <sup> chnages -------


// ------------------- Adjust the top of the sticky box -------

function closemq() {
  const marqueecl = document.querySelector(".mob-marquee-span");
  marqueecl.classList.toggle("close");

//Adjust the top of the sticky box
  const isClosed = marqueecl.classList.contains("close");
  
  const stickyBox = document.querySelector(".collection-sticky-box");
  
  if (isClosed) {
    stickyBox.style.top = '11.5vw';
  } else {
    stickyBox.style.top = '18.5vw';
  }
}

// ------------------- Adjust the top of the sticky box end-------


// ------------ mobile menu x design -----

const toggleBtn = document.querySelector('.toggle-btn-d');
const mobMenuBox = document.querySelector('.mob-menu-box');

toggleBtn.addEventListener('click', () => {
  toggleBtn.classList.toggle('active');
  mobMenuBox.classList.toggle('active');
});

// ------------ mobile menu x design -----


// ------- mobile menu inner tabs --------

  document.addEventListener("DOMContentLoaded", function () {
    const menuBox = document.querySelector(".mob-menu-box");

    if (!menuBox) return; // Exit if not present

    const tabs = menuBox.querySelectorAll(".menu-tab-list li");
    const contents = menuBox.querySelectorAll(".menu-tab-content");

    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        // Handle active class on tabs
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        const target = this.dataset.target;

        // Show matching content block
        contents.forEach(content => {
          content.classList.toggle("show", content.dataset.content === target);
        });
      });
    });
  });


// ------- mobile menu inner tabs --------

// --- STOP SCROLL ON MOBILE MENU BOX OPEN ---  
const mob_menuBox = document.querySelector('.mob-menu-box');
  if (mob_menuBox) {
    new MutationObserver(() => {
      const ismenuActive = mob_menuBox.classList.contains('active');
      document.documentElement.classList.toggle('lock-search', ismenuActive);
      document.body.classList.toggle('lock-search', ismenuActive);
      if (isAnyScrollLockActive()) {
        lenis?.stop?.();
      } else {
        lenis?.start?.();
      }
    }).observe(mob_menuBox, { attributes: true, attributeFilter: ['class'] });
  }
// --- STOP SCROLL ON MOBILE MENU BOX OPEN ---


// --- when open search and mobile menu set z-index:0 to sticky box -----

document.addEventListener("DOMContentLoaded", () => {
  const stickyBox = document.querySelector('.collection-sticky-box');
  const checkZIndex = () => {
    const isSearchActive = document.querySelector('.my-search-box')?.classList.contains('active');
    const isMenuActive = document.querySelector('.mob-menu-box')?.classList.contains('active');
    
    stickyBox.style.zIndex = (isSearchActive || isMenuActive) ? '0' : '';
  };

  ['.my-search-box', '.mob-menu-box'].forEach(selector => {
    const el = document.querySelector(selector);
    if (!el) return;
    new MutationObserver(checkZIndex).observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
});

// ------------- Desktop Shop All Hover set z-index:0 to sticky box--------------------

const plzHoverme = document.querySelector('.plz-hoverme');
const stickyBox = document.querySelector('.collection-sticky-box');
const originalZIndex = window.getComputedStyle(stickyBox).zIndex;

plzHoverme.addEventListener('mouseenter', () => {
  stickyBox.style.zIndex = '0';
});

plzHoverme.addEventListener('mouseleave', () => {
  stickyBox.style.zIndex = originalZIndex;
});

// ------------- Desktop Shop All Hover set z-index:0 to sticky box--------------------



// --- when open search and mobile menu set z-index:0 to sticky box -----


// ========================= Quick Add Cart Drawer Function========================================

document.addEventListener("click", function (event) {
  // Check if the clicked element has the class .quick-add-btn
  const clickedElement = event.target;
  if(clickedElement.nodeName == "svg" || clickedElement.nodeName == "path" || clickedElement.nodeName == "g"){
    let mainEl = clickedElement.closest('.quick-add-btn');
     quickAddCartDrawer(mainEl);
    return
  }
  // ============== If Clicked on Quick Add Btn Then call Function ===============
  if (clickedElement.classList.contains("quick-add-btn")) {
    quickAddCartDrawer(clickedElement);
  }
});

function quickAddCartDrawer(clickedElemrnt) {
  const productId = clickedElemrnt.getAttribute("data-product-id");
  const variantId = clickedElemrnt.getAttribute("data-variant-id");
  const cartDrawer = document.querySelector(".drawer__cart-items-wrapper");
  // Make sure the product ID and variant ID exist
  if (!productId || !variantId) {
    console.error("Product ID or Variant ID is missing.");
    return;
  }

  // Add the product to the cart via Shopify AJAX API
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId, // Use the variant ID from the clicked button
      quantity: 1, // Adding 1 quantity
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Added to cart:", data);
      // Optionally, update UI (like cart count, etc.)
      updateCartUI();
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
  // Function to update the cart UI (like cart count)
  function updateCartUI() {
    fetch("/cart")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const updatedCartDrawer = doc.querySelector(
          ".drawer__cart-items-wrapper"
        );

        if (cartDrawer && updatedCartDrawer) {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              document.querySelector(".cart-count-bubble").textContent =
                data.item_count;
            });
          cartDrawer.innerHTML = updatedCartDrawer.innerHTML;
        }
      })
      .catch((error) => {
        console.error("Error updating cart UI:", error);
      });
  }
}
// ========================= Quick Add Cart Drawer Function [END]========================================z




// product-tags

function setProductTags(product){
  const tags = JSON.parse(product.getAttribute("data-value"))
  if(tags.length>0){
    const countLi = product.querySelectorAll("li").length;
    for(let i = 0 ; i<(2-countLi) ; i++){
      let newLi = document.createElement("li");
      newLi.textContent = tags[i];
      product.appendChild(newLi)
    }
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const allCardTags = document.querySelectorAll(".product-tags");
  if(!allCardTags) return;
  allCardTags.forEach((productTags)=>{
    setProductTags(productTags);
  })
})


// product-tags